import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uniqueUuid} from "@vesta/unique/unique";
import {OttopilotAdditionalButtonKind, OttopilotAdditionalButtonFormFieldPresentation, OttopilotAdditionalButtonFormFieldRole, OttopilotOperator, OttopilotRunTimeValueKind, type OttopilotAdditionalButtonVisibilityRule, type OttopilotAdditionalButtonsConfig} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/ottopilotEventsWorkspaceCapability/domain/OttopilotEventAdditionalButtonsConfig";
import {OttopilotDispositionEmitWhen,
OttopilotDispositionOptionRuleActionKind,
OttopilotDispositionOptionRuleCountMode,
OttopilotDispositionPluginKind,
OttopilotSuggestedJourneyStatusRuleKind} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/ottopilotEventContainersWorkspaceCapability/domain/OttopilotEventContainerDispositionConfig";
import type {OttopilotDispositionConfig} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/ottopilotEventContainersWorkspaceCapability/domain/OttopilotEventContainerDispositionConfig";
import type {OttopilotTriggerConfig} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/ottopilotEventContainersWorkspaceCapability/domain/OttopilotEventContainerTriggerConfig";
import {OttopilotScheduleValueEncoding,
OttopilotTrigger,
OttopilotTriggerDataDriver} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/ottopilotEventContainersWorkspaceCapability/domain/OttopilotEventContainerTriggerConfig";
import {
    BOBCARD__CALL__EDIT__FORM__ID,
    BOBCARD__CALL__LOG__FORM__ID,
    BOBCARD__CALL__SCHEDULE__FORM__ID,
    BOBCARD__EVENT__CALL__FBCLID__COLUMN_ID,
    BOBCARD__EVENT__CALL__GCLID__COLUMN_ID,
    BOBCARD__EVENT__CALLS__CALL_DISPOSITION__COLUMN_ID,
    BOBCARD__EVENT__CALLS__CALL_DURATION__COLUMN_ID,
    BOBCARD__EVENT__CALLS__CALL_END_TIME__COLUMN_ID,
    BOBCARD__EVENT__CALLS__CALL_START_TIME__COLUMN_ID,
    BOBCARD__EVENT__CALLS__CALL_TYPE__COLUMN_ID,
    BOBCARD__EVENT__CALLS__CANCELLATION_REMARKS__COLUMN_ID,
    BOBCARD__EVENT__CALLS__CANCELLED_BY__COLUMN_ID,
    BOBCARD__EVENT__CALLS__CANCELLED_ON__COLUMN_ID,
    BOBCARD__EVENT__CALLS__LEAD_OWNER__COLUMN_ID,
    BOBCARD__EVENT__CALLS__LOGGED_BY__COLUMN_ID,
    BOBCARD__EVENT__CALLS__LOGGED_CALL_REMARKS__COLUMN_ID,
    BOBCARD__EVENT__CALLS__LOGGED_ON__COLUMN_ID,
    BOBCARD__EVENT__CALLS__SCHEDULED_BY__COLUMN_ID,
    BOBCARD__EVENT__CALLS__SCHEDULED_ON__COLUMN_ID,
    BOBCARD__EVENT__CALLS__STATUS__COLUMN_ID,
    BOBCARD__EVENT__CALLS__UTM_CAMPAIGN__COLUMN_ID,
    BOBCARD__EVENT__CALLS__UTM_CONTENT__COLUMN_ID,
    BOBCARD__EVENT__CALLS__UTM_MEDIUM__COLUMN_ID,
    BOBCARD__EVENT__CALLS__UTM_PLATFORM__COLUMN_ID,
    BOBCARD__EVENT__CALLS__UTM_SOURCE__COLUMN_ID,
    BOBCARD__EVENT__CALLS__UTM_TERM__COLUMN_ID,
    BOBCARD__EVENT__ENQUIRY__CONTACT_NUMBER__COLUMN_ID,
    BOBCARD__EVENT__ENQUIRY__CUSTOMER_NAME__COLUMN_ID,
    BOBCARD__EVENT__ENQUIRY__DIGITAL_LEAD_STATUS__COLUMN_ID,
    BOBCARD__EVENT__ENQUIRY__FBCLID__COLUMN_ID,
    BOBCARD__EVENT__ENQUIRY__GCLID__COLUMN_ID,
    BOBCARD__EVENT__ENQUIRY__REFERRER__COLUMN_ID,
    BOBCARD__EVENT__ENQUIRY__UTM_CAMPAIGN__COLUMN_ID,
    BOBCARD__EVENT__ENQUIRY__UTM_CONTENT__COLUMN_ID,
    BOBCARD__EVENT__ENQUIRY__UTM_MEDIUM__COLUMN_ID,
    BOBCARD__EVENT__ENQUIRY__UTM_PLATFORM__COLUMN_ID,
    BOBCARD__EVENT__ENQUIRY__UTM_SOURCE__COLUMN_ID,
    BOBCARD__EVENT__ENQUIRY__UTM_TERM__COLUMN_ID,
    BobcardCallStatusEnum,
    bobcardCallStatuses,
    BobcardEventCallDispositionEnum,
    bobcardEventCallDispositions,
    BobcardEventTypes,
    EventCallType,
    getBobcardCallStatuses,
    getBobcardEventCallDispositions,
} from "@vesta/vos-types/modules/workspaceLevel/workspaceSpecific/domain/bobcard/Events";
import {
    BOBCARD__EVENT_CONTAINER__AADHAR_NUMBER__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__AADHAR_VERIFICATION__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__ALIAS_ID__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__APPLICATION_ID__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__APPLICATION_STAGE__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__ASSIGNED_ON__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__CALLS_COUNT__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__COMPANY_ADDRESS__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__COMPANY_NAME__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__CONTACT_NUMBER__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__CREDIT_HISTORY__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__CREDIT_SCORE__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__CURRENT_ADDRESS__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__CURRENT_PINCODE__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__CUSTOMER_NAME__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__DATE_OF_BIRTH__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__E_CONSENT__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__EMAIL_ADDRESS__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__EMPLOYMENT_STATUS__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__ENQUIRY_COUNT__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__FBCLID__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__FIRST_NAME__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__GCLID__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__GENDER__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__INTERESTED_CARD_VARIANT__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__LAST_ACTIVITY__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__LAST_ACTIVITY_ON__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__LAST_NAME__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__LEAD_COUNT__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__LEAD_OWNER__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__MARITAL_STATUS__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__NET_MONTHLY_INCOME_NET_ANNUAL__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__NETWORK_SELECTED__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__PAN_NUMBER__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__PAN_VALIDATION__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__PERMANENT_ADDRESS__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__REFERRER__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__REJECTION_STAGE__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__REMARKS_RECENT__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__SELECTED_CARD_VARIANT__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__STATUS__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__UPI_LINKAGE__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__UTM_CAMPAIGN__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__UTM_CONTENT__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__UTM_MEDIUM__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__UTM_PLATFORM__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__UTM_SOURCE__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__UTM_TERM__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__V_KYC_SUCCESSFUL__COLUMN_ID,
    BobcardApplicationStageEnum,
    bobcardApplicationStages,
    BobcardApplicationStatusEnum,
    bobcardApplicationStatuses,
    BobcardCardVariantEnum,
    bobcardCardVariants,
    BobcardEnquiryDigitalLeadStatusEnum,
    bobcardEnquiryDigitalLeadStatuses,
    BobcardEnquiryDispositionEnum,
    bobcardEnquiryDispositions,
    BobcardGenderEnum,
    bobcardGenders,
    BobcardEventContainerCardNetworkEnum,
    bobcardEventContainerCardNetworks,
    BobcardEventContainerDispositionEnum,
    bobcardEventContainerDispositions,
    BobcardEventContainerEmploymentStatusEnum,
    bobcardEventContainerEmploymentStatuses,
    BobcardEventContainerGenderEnum,
    bobcardEventContainerGenders,
    BobcardEventContainerMaritalStatusEnum,
    bobcardEventContainerMaritalStatuses,
    BobcardEventContainerStatusEnum,
    bobcardEventContainerStatuses,
    BobcardEventContainerYesNoEnum,
    bobcardEventContainerYesNoOptions,
    BobcardRejectionStageEnum,
    bobcardRejectionStages,
    getBobcardApplicationStageSelectOptions,
    getBobcardApplicationStatuses,
    getBobcardCardVariantSelectOptions,
    getBobcardEnquiryDigitalLeadStatuses,
    getBobcardEnquiryDispositions,
    getBobcardEventContainerDispositions,
    getBobcardEventContainerEmploymentStatusSelectOptions,
    getBobcardEventContainerGenderSelectOptions,
    getBobcardEventContainerMaritalStatusSelectOptions,
    getBobcardEventContainerNetworkSelectedSelectOptions,
    getBobcardEventContainerStatuses,
    getBobcardEventContainerYesNoSelectOptions,
    getBobcardRejectionStageSelectOptions,
} from "@vesta/vos-types/modules/workspaceLevel/workspaceSpecific/domain/bobcard/EventContainers";
import {
    BOBCARD__OU__COUNTRY__NAME__COLUMN_ID,
    BobcardOus,
} from "@vesta/vos-types/modules/workspaceLevel/workspaceSpecific/domain/bobcard/OrganizationalUnits";
import {
    BOBCARD__USER__CONTACT_NUMBER__COLUMN_ID,
    BOBCARD__USER__COUNTRY__COLUMN_ID,
    BOBCARD__USER__DISPLAY_NAME__COLUMN_ID,
    BOBCARD__USER__DOB__COLUMN_ID,
    BOBCARD__USER__EMAIL__COLUMN_ID,
    BOBCARD__USER__GENDER__COLUMN_ID,
    BOBCARD__USER__NAME__COLUMN_ID,
    BOBCARD__USER__PROFILE_IMAGE_URL__COLUMN_ID,
    BOBCARD__USER__STAFF_CODE__COLUMN_ID,
    BOBCARD__USER__VERIFICATION_INVITED_AT__COLUMN_ID,
    BOBCARD__USER__VERIFICATION_INVITED_BY__COLUMN_ID,
    BOBCARD__USER__VERIFICATION_PROCESSED_BY__COLUMN_ID,
    BOBCARD__USER__VERIFICATION_PROCESSED_ON__COLUMN_ID,
    BOBCARD__USER__VERIFICATION_REJECT_REASON__COLUMN_ID,
    BOBCARD__USER__VERIFICATION_SUBMITTED_ON__COLUMN_ID,
    BobcardRoles,
} from "@vesta/vos-types/modules/workspaceLevel/workspaceSpecific/domain/bobcard/Users";
import {
    BobcardModuleNames,
} from "@vesta/vos-types/modules/workspaceLevel/workspaceSpecific/domain/bobcard/Workspace";

export {
    bobcardCallStatuses,
    bobcardEventCallDispositions,
    bobcardGenders,
    bobcardEventContainerDispositions,
    getBobcardEventContainerDispositions,
    getBobcardCallStatuses,
    getBobcardEventCallDispositions,
    bobcardEventContainerStatuses,
    getBobcardEventContainerStatuses,
    bobcardApplicationStatuses,
    getBobcardApplicationStatuses,
    bobcardApplicationStages,
    getBobcardApplicationStageSelectOptions,
    bobcardRejectionStages,
    getBobcardRejectionStageSelectOptions,
    bobcardCardVariants,
    getBobcardCardVariantSelectOptions,
    bobcardEventContainerEmploymentStatuses,
    getBobcardEventContainerEmploymentStatusSelectOptions,
    bobcardEventContainerGenders,
    getBobcardEventContainerGenderSelectOptions,
    bobcardEventContainerMaritalStatuses,
    getBobcardEventContainerMaritalStatusSelectOptions,
    bobcardEventContainerCardNetworks,
    getBobcardEventContainerNetworkSelectedSelectOptions,
    bobcardEventContainerYesNoOptions,
    getBobcardEventContainerYesNoSelectOptions,
    bobcardEnquiryDigitalLeadStatuses,
    getBobcardEnquiryDigitalLeadStatuses,
    bobcardEnquiryDispositions,
    getBobcardEnquiryDispositions,
};
export {
    BobcardOus,
    BobcardRoles,
    BobcardModuleNames,
    BobcardEventTypes,
    BOBCARD__OU__COUNTRY__NAME__COLUMN_ID,
    BOBCARD__USER__NAME__COLUMN_ID,
    BOBCARD__USER__DISPLAY_NAME__COLUMN_ID,
    BOBCARD__USER__EMAIL__COLUMN_ID,
    BOBCARD__USER__CONTACT_NUMBER__COLUMN_ID,
    BOBCARD__USER__DOB__COLUMN_ID,
    BOBCARD__USER__GENDER__COLUMN_ID,
    BOBCARD__USER__STAFF_CODE__COLUMN_ID,
    BOBCARD__USER__PROFILE_IMAGE_URL__COLUMN_ID,
    BOBCARD__USER__VERIFICATION_INVITED_AT__COLUMN_ID,
    BOBCARD__USER__VERIFICATION_INVITED_BY__COLUMN_ID,
    BOBCARD__USER__VERIFICATION_SUBMITTED_ON__COLUMN_ID,
    BOBCARD__USER__VERIFICATION_PROCESSED_ON__COLUMN_ID,
    BOBCARD__USER__VERIFICATION_PROCESSED_BY__COLUMN_ID,
    BOBCARD__USER__VERIFICATION_REJECT_REASON__COLUMN_ID,
    BOBCARD__USER__COUNTRY__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__CUSTOMER_NAME__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__FIRST_NAME__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__LAST_NAME__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__APPLICATION_STAGE__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__REJECTION_STAGE__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__CONTACT_NUMBER__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__STATUS__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__LAST_ACTIVITY__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__LAST_ACTIVITY_ON__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__ENQUIRY_COUNT__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__CALLS_COUNT__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__REMARKS_RECENT__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__LEAD_OWNER__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__ASSIGNED_ON__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__UTM_PLATFORM__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__UTM_SOURCE__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__UTM_MEDIUM__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__UTM_CAMPAIGN__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__UTM_TERM__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__UTM_CONTENT__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__FBCLID__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__GCLID__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__REFERRER__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__DATE_OF_BIRTH__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__APPLICATION_ID__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__ALIAS_ID__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__EMPLOYMENT_STATUS__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__NET_MONTHLY_INCOME_NET_ANNUAL__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__CURRENT_PINCODE__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__GENDER__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__MARITAL_STATUS__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__EMAIL_ADDRESS__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__PAN_NUMBER__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__COMPANY_NAME__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__COMPANY_ADDRESS__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__PERMANENT_ADDRESS__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__CURRENT_ADDRESS__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__PAN_VALIDATION__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__CREDIT_HISTORY__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__CREDIT_SCORE__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__AADHAR_NUMBER__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__AADHAR_VERIFICATION__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__NETWORK_SELECTED__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__E_CONSENT__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__V_KYC_SUCCESSFUL__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__UPI_LINKAGE__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__INTERESTED_CARD_VARIANT__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__SELECTED_CARD_VARIANT__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__LEAD_COUNT__COLUMN_ID,
    BOBCARD__CALL__SCHEDULE__FORM__ID,
    BOBCARD__CALL__LOG__FORM__ID,
    BOBCARD__CALL__EDIT__FORM__ID,
    BOBCARD__EVENT__CALLS__CALL_TYPE__COLUMN_ID,
    BOBCARD__EVENT__CALLS__STATUS__COLUMN_ID,
    BOBCARD__EVENT__CALLS__CALL_DISPOSITION__COLUMN_ID,
    BOBCARD__EVENT__CALLS__LOGGED_CALL_REMARKS__COLUMN_ID,
    BOBCARD__EVENT__CALLS__CALL_START_TIME__COLUMN_ID,
    BOBCARD__EVENT__CALLS__CALL_END_TIME__COLUMN_ID,
    BOBCARD__EVENT__CALLS__CALL_DURATION__COLUMN_ID,
    BOBCARD__EVENT__CALLS__SCHEDULED_BY__COLUMN_ID,
    BOBCARD__EVENT__CALLS__SCHEDULED_ON__COLUMN_ID,
    BOBCARD__EVENT__CALLS__LOGGED_BY__COLUMN_ID,
    BOBCARD__EVENT__CALLS__LOGGED_ON__COLUMN_ID,
    BOBCARD__EVENT__CALLS__CANCELLED_BY__COLUMN_ID,
    BOBCARD__EVENT__CALLS__CANCELLED_ON__COLUMN_ID,
    BOBCARD__EVENT__CALLS__CANCELLATION_REMARKS__COLUMN_ID,
    BOBCARD__EVENT__CALLS__LEAD_OWNER__COLUMN_ID,
    BOBCARD__EVENT__CALLS__UTM_PLATFORM__COLUMN_ID,
    BOBCARD__EVENT__CALLS__UTM_SOURCE__COLUMN_ID,
    BOBCARD__EVENT__CALLS__UTM_MEDIUM__COLUMN_ID,
    BOBCARD__EVENT__CALLS__UTM_CAMPAIGN__COLUMN_ID,
    BOBCARD__EVENT__CALLS__UTM_TERM__COLUMN_ID,
    BOBCARD__EVENT__CALLS__UTM_CONTENT__COLUMN_ID,
    BOBCARD__EVENT__ENQUIRY__CUSTOMER_NAME__COLUMN_ID,
    BOBCARD__EVENT__ENQUIRY__CONTACT_NUMBER__COLUMN_ID,
    BOBCARD__EVENT__ENQUIRY__DIGITAL_LEAD_STATUS__COLUMN_ID,
    BOBCARD__EVENT__ENQUIRY__UTM_PLATFORM__COLUMN_ID,
    BOBCARD__EVENT__ENQUIRY__UTM_SOURCE__COLUMN_ID,
    BOBCARD__EVENT__ENQUIRY__UTM_MEDIUM__COLUMN_ID,
    BOBCARD__EVENT__ENQUIRY__UTM_CAMPAIGN__COLUMN_ID,
    BOBCARD__EVENT__ENQUIRY__UTM_TERM__COLUMN_ID,
    BOBCARD__EVENT__ENQUIRY__UTM_CONTENT__COLUMN_ID,
    BOBCARD__EVENT__ENQUIRY__FBCLID__COLUMN_ID,
    BOBCARD__EVENT__ENQUIRY__GCLID__COLUMN_ID,
    BOBCARD__EVENT__ENQUIRY__REFERRER__COLUMN_ID,
    BOBCARD__EVENT__CALL__FBCLID__COLUMN_ID,
    BOBCARD__EVENT__CALL__GCLID__COLUMN_ID,
    EventCallType,
    BobcardCallStatusEnum,
    BobcardEventCallDispositionEnum,
    BobcardGenderEnum,
    BobcardEventContainerDispositionEnum,
    BobcardEventContainerStatusEnum,
    BobcardApplicationStatusEnum,
    BobcardApplicationStageEnum,
    BobcardRejectionStageEnum,
    BobcardCardVariantEnum,
    BobcardEventContainerEmploymentStatusEnum,
    BobcardEventContainerGenderEnum,
    BobcardEventContainerMaritalStatusEnum,
    BobcardEventContainerCardNetworkEnum,
    BobcardEventContainerYesNoEnum,
    BobcardEnquiryDigitalLeadStatusEnum,
    BobcardEnquiryDispositionEnum,
};

// Organizational Unit Template IDs
// User Template IDs
// Module instance IDs (workspace configuration)
// Organizational Unit Column IDs

// User Column IDs

// Journey Column IDs — BobCard credit-card leads (journeys = leads)
/** Journey additional column: Application Stage (select; see `BobcardApplicationStageEnum`). */
/** Journey additional column: Rejection Stage (select; see `BobcardRejectionStageEnum`). */
/** Lead lifecycle: Live, Churned, Archive (system-driven; not workspace draft/archived). */
/** Marketing / attribution text — journey roll-up. */
// Call event form IDs

// Event (call) column IDs

// Enquiry event column IDs (first event in journey; digital ingest only, view-only module in UI)
/** Applications initiated (enquiry) event — referrer at ingest. */
/** URL pattern for scheduling/logging calls (uses workspace call event template id). */
export const BOBCARD__CALL_EVENT_CREATE_URL =
    `/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/ottopilot/_ottopilotScaffold/events/${BobcardEventTypes.call}/create` as const;

/** Applications Initiated events are created from digital ingestion only. */
export const BOBCARD__APPLICATIONS_INITIATED_EVENT_CREATE_URL =
    `/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/ottopilot/_ottopilotScaffold/events/${BobcardEventTypes.applicationsInitiated}/create` as const;
/** @deprecated Use `BOBCARD__APPLICATIONS_INITIATED_EVENT_CREATE_URL`. */
export const BOBCARD__ENQUIRY_EVENT_CREATE_URL = BOBCARD__APPLICATIONS_INITIATED_EVENT_CREATE_URL;

// Call status (event lifecycle)
export function isBobcardWorkspace(workspace: {displayName: string}): boolean {
    const name = workspace.displayName.toLowerCase();
    return (name.includes("bobcard") || name.includes("bob card"))
        && name.includes("ottopilot");
}

const bobcardCallScheduledVisibilityRule: OttopilotAdditionalButtonVisibilityRule = {
    conditions: [
        {
            attribute: BOBCARD__EVENT__CALLS__STATUS__COLUMN_ID,
            operator: OttopilotOperator.equals,
            kind: OttopilotRunTimeValueKind.static,
            value: BobcardCallStatusEnum.SCHEDULED as string,
        },
    ],
    logicalOperator: "and",
};

/** Additional actions for the Bobcard call event template when the call is scheduled. */
export const BOBCARD__CALL_EVENT__ADDITIONAL_BUTTONS: Array<OttopilotAdditionalButtonsConfig> = [
    {
        id: "f7e2c8a4-1b9d-4f3a-8e2c-6d5f4a3b2e10" as Uuid,
        label: "Cancel call",
        buttonKind: OttopilotAdditionalButtonKind.cancel,
        rules: [bobcardCallScheduledVisibilityRule],
        showModal: true,
        formColumnData: [
            {
                columnId: BOBCARD__EVENT__CALLS__CANCELLED_BY__COLUMN_ID,
                columnType: "OttopilotEvent",
                isVisible: false,
                isRequired: true,
                kind: OttopilotRunTimeValueKind.user,
                sortOrder: 0,
            },
            {
                columnId: BOBCARD__EVENT__CALLS__CANCELLED_ON__COLUMN_ID,
                columnType: "OttopilotEvent",
                isVisible: false,
                isRequired: true,
                kind: OttopilotRunTimeValueKind.timestamp,
                sortOrder: 1,
            },
            {
                columnId: BOBCARD__EVENT__CALLS__CANCELLATION_REMARKS__COLUMN_ID,
                columnType: "OttopilotEvent",
                fieldRole: OttopilotAdditionalButtonFormFieldRole.cancelRemarks,
                isVisible: true,
                isRequired: true,
                kind: OttopilotRunTimeValueKind.static,
                presentation: OttopilotAdditionalButtonFormFieldPresentation.multiLineText,
                sortOrder: 2,
            },
            {
                columnId: BOBCARD__EVENT__CALLS__STATUS__COLUMN_ID,
                columnType: "OttopilotEvent",
                isVisible: false,
                isRequired: true,
                kind: OttopilotRunTimeValueKind.static,
                defaultValue: BobcardCallStatusEnum.CANCELLED as string,
                sortOrder: 3,
            },
        ],
    },
    {
        id: "e6d1a7b3-0a8c-4e29-9d1b-5c4e3f2a1b09" as Uuid,
        label: "Log call",
        buttonKind: OttopilotAdditionalButtonKind.log,
        rules: [bobcardCallScheduledVisibilityRule],
        formUrl: "bobcard/call/log",
        formUrlQueryParams: ["eventContainerId", "eventId"],
    },
];

/**
 * Maps Issuance CRM application stage → journey Application Status (same column as workspace select).
 * When application stage is edited, callers merge the corresponding status UUID into the journey update payload.
 */
const bobcardApplicationStageEnumToApplicationStatusEnum: Record<
    BobcardApplicationStageEnum,
    BobcardApplicationStatusEnum
> = {
    [BobcardApplicationStageEnum.CARD_APPROVED]: BobcardApplicationStatusEnum.ONBOARDED,
    [BobcardApplicationStageEnum.CARD_CONFIGURATION]: BobcardApplicationStatusEnum.ONBOARDED,
    [BobcardApplicationStageEnum.APPLICATION_REJECTED]: BobcardApplicationStatusEnum.REJECTED,
    [BobcardApplicationStageEnum.APPLICATION_APPROVED]: BobcardApplicationStatusEnum.ONBOARDED,
    [BobcardApplicationStageEnum.APPLICATION_HOLD]: BobcardApplicationStatusEnum.ON_HOLD,
    [BobcardApplicationStageEnum.CAF_PERSONAL_DETAILS]: BobcardApplicationStatusEnum.IN_PROGRESS,
    [BobcardApplicationStageEnum.CAF_EMAIL]: BobcardApplicationStatusEnum.IN_PROGRESS,
    [BobcardApplicationStageEnum.CUSTOMER_DEDUPE]: BobcardApplicationStatusEnum.IN_PROGRESS,
    [BobcardApplicationStageEnum.PROGRAM_CONSENTS]: BobcardApplicationStatusEnum.IN_PROGRESS,
    [BobcardApplicationStageEnum.PAN_VALIDATION]: BobcardApplicationStatusEnum.IN_PROGRESS,
    [BobcardApplicationStageEnum.PAN_VERIFY_SUCCESS]: BobcardApplicationStatusEnum.IN_PROGRESS,
    [BobcardApplicationStageEnum.AADHAAR_VALIDATION]: BobcardApplicationStatusEnum.IN_PROGRESS,
    [BobcardApplicationStageEnum.RE_AADHAAR_VALIDATION]: BobcardApplicationStatusEnum.IN_PROGRESS,
    [BobcardApplicationStageEnum.AADHAAR_VERIFY_SUCCESS]: BobcardApplicationStatusEnum.IN_PROGRESS,
    [BobcardApplicationStageEnum.CAF_PERMANENT_ADDRESS]: BobcardApplicationStatusEnum.IN_PROGRESS,
    [BobcardApplicationStageEnum.CAF_CURRENT_ADDRESS]: BobcardApplicationStatusEnum.IN_PROGRESS,
    [BobcardApplicationStageEnum.CAF_ADDITIONAL_DETAILS]: BobcardApplicationStatusEnum.IN_PROGRESS,
    [BobcardApplicationStageEnum.CAF_MOBILE_NUMBER]: BobcardApplicationStatusEnum.IN_PROGRESS,
    [BobcardApplicationStageEnum.UPDATE_BULK_ADDRESS]: BobcardApplicationStatusEnum.IN_PROGRESS,
    [BobcardApplicationStageEnum.LIMIT_ENHANCEMENT]: BobcardApplicationStatusEnum.IN_PROGRESS,
    [BobcardApplicationStageEnum.LIMIT_ENHANCEMENT_AA]: BobcardApplicationStatusEnum.IN_PROGRESS,
    [BobcardApplicationStageEnum.EMPLOYER_ADDRESS]: BobcardApplicationStatusEnum.IN_PROGRESS,
    [BobcardApplicationStageEnum.UNDERWRITING]: BobcardApplicationStatusEnum.IN_PROGRESS,
    [BobcardApplicationStageEnum.AA_UNDERWRITING]: BobcardApplicationStatusEnum.IN_PROGRESS,
    [BobcardApplicationStageEnum.FETCH_CREDIT_BUREAU]: BobcardApplicationStatusEnum.IN_PROGRESS,
    [BobcardApplicationStageEnum.ACCOUNT_AGGREGATOR]: BobcardApplicationStatusEnum.IN_PROGRESS,
    [BobcardApplicationStageEnum.OFFER_CREATED]: BobcardApplicationStatusEnum.IN_PROGRESS,
    [BobcardApplicationStageEnum.CARD_SELECTION]: BobcardApplicationStatusEnum.IN_PROGRESS,
    [BobcardApplicationStageEnum.CARD_DETAILS]: BobcardApplicationStatusEnum.IN_PROGRESS,
    [BobcardApplicationStageEnum.VIDEO_KYC]: BobcardApplicationStatusEnum.IN_PROGRESS,
    [BobcardApplicationStageEnum.E_SIGN_CONSENT_COMPLETED]: BobcardApplicationStatusEnum.IN_PROGRESS,
    [BobcardApplicationStageEnum.GENERATE_CAF_DOCUMENT]: BobcardApplicationStatusEnum.IN_PROGRESS,
    [BobcardApplicationStageEnum.AGREEMENT_SIGNED]: BobcardApplicationStatusEnum.IN_PROGRESS,
    [BobcardApplicationStageEnum.E_SIGN_AGREEMENT]: BobcardApplicationStatusEnum.IN_PROGRESS,
    [BobcardApplicationStageEnum.E_SIGN_CONSENT]: BobcardApplicationStatusEnum.IN_PROGRESS,
    [BobcardApplicationStageEnum.VKYC_FINAL_VERIFICATION]: BobcardApplicationStatusEnum.IN_PROGRESS,
    [BobcardApplicationStageEnum.LP_LEAD_CREATED]: BobcardApplicationStatusEnum.NOT_STARTED,
    [BobcardApplicationStageEnum.LP_OTP_VERIFIED]: BobcardApplicationStatusEnum.NOT_STARTED,
};

export function getBobcardApplicationStatusUuidForApplicationStageUuid(
    applicationStageUuid: Uuid | null | undefined
): Uuid | null {
    if (applicationStageUuid === null || applicationStageUuid === undefined) {
        return null;
    }
    const statusEnum =
        bobcardApplicationStageEnumToApplicationStatusEnum[applicationStageUuid as BobcardApplicationStageEnum];
    if (statusEnum === undefined) {
        return null;
    }
    return bobcardApplicationStatuses[statusEnum].id;
}

/**
 * Use when sending the full journey `additionalColumnValues` (e.g. list edit panel save).
 * Sets Application Status when Application Stage differs from `previousAdditionalColumnValues`.
 */
export function mergeBobcardJourneyAdditionalColumnValuesWithApplicationStatusWhenApplicationStageChanges(
    nextAdditionalColumnValues: Record<Uuid, unknown>,
    previousAdditionalColumnValues: Record<Uuid, unknown>
): Record<Uuid, unknown> {
    const nextStage = nextAdditionalColumnValues[BOBCARD__EVENT_CONTAINER__APPLICATION_STAGE__COLUMN_ID];
    const prevStage = previousAdditionalColumnValues[BOBCARD__EVENT_CONTAINER__APPLICATION_STAGE__COLUMN_ID];
    if (typeof nextStage !== "string" || nextStage === "") {
        return nextAdditionalColumnValues;
    }
    if (prevStage === nextStage) {
        return nextAdditionalColumnValues;
    }
    const statusUuid = getBobcardApplicationStatusUuidForApplicationStageUuid(nextStage as Uuid);
    if (statusUuid === null) {
        return nextAdditionalColumnValues;
    }
    return {
        ...nextAdditionalColumnValues,
        [BOBCARD__EVENT_CONTAINER__STATUS__COLUMN_ID]: statusUuid,
    };
}

/**
 * Use when sending a partial diff of journey columns (e.g. journey details tab save).
 * If Application Stage is in the diff and changed vs the journey, merges Application Status into the diff.
 */
export function mergeBobcardJourneyPartialDiffWithApplicationStatusWhenApplicationStageChanges(
    diffAdditionalColumnValues: Record<Uuid, unknown>,
    journeyAdditionalColumnValues: Record<Uuid, unknown>
): Record<Uuid, unknown> {
    if (
        Object.prototype.hasOwnProperty.call(
            diffAdditionalColumnValues,
            BOBCARD__EVENT_CONTAINER__APPLICATION_STAGE__COLUMN_ID
        ) !== true
    ) {
        return diffAdditionalColumnValues;
    }
    const nextStage = diffAdditionalColumnValues[BOBCARD__EVENT_CONTAINER__APPLICATION_STAGE__COLUMN_ID];
    const prevStage = journeyAdditionalColumnValues[BOBCARD__EVENT_CONTAINER__APPLICATION_STAGE__COLUMN_ID];
    if (typeof nextStage !== "string" || nextStage === "") {
        return diffAdditionalColumnValues;
    }
    if (prevStage === nextStage) {
        return diffAdditionalColumnValues;
    }
    const statusUuid = getBobcardApplicationStatusUuidForApplicationStageUuid(nextStage as Uuid);
    if (statusUuid === null) {
        return diffAdditionalColumnValues;
    }
    return {
        ...diffAdditionalColumnValues,
        [BOBCARD__EVENT_CONTAINER__STATUS__COLUMN_ID]: statusUuid,
    };
}

/**
 * Active / inactive application-status UUID groups for the events table "Display by" journey scope filter.
 * Returns null when the workspace is not Bobcard — the control is not rendered.
 */
export function getBobcardJourneyScopeFilterStatusIdsForEvents(workspace: {
    displayName: string;
}): {
    activeStatusIds: Array<Uuid>;
    inactiveStatusIds: Array<Uuid>;
} | null {
    if (isBobcardWorkspace(workspace) !== true) {
        return null;
    }
    return {
        activeStatusIds: [
            BobcardApplicationStatusEnum.NOT_STARTED as Uuid,
            BobcardApplicationStatusEnum.IN_PROGRESS as Uuid,
            BobcardApplicationStatusEnum.ON_HOLD as Uuid,
        ],
        inactiveStatusIds: [
            BobcardApplicationStatusEnum.CHURNED as Uuid,
            BobcardApplicationStatusEnum.REJECTED as Uuid,
            BobcardApplicationStatusEnum.ONBOARDED as Uuid,
        ],
    };
}

export const BOBCARD_DEFAULT_JOURNEY_TRIGGER_CONFIG: OttopilotTriggerConfig = [
    {
        type: OttopilotTrigger.dateTimeTrigger,
        eventTemplateId: BobcardEventTypes.call as Uuid,
        triggerDispositions: [bobcardEventContainerDispositions[BobcardEventContainerDispositionEnum.CONNECTED_CALL_BACK_LATER].id],
        dataColumns: [
            {
                columnId: BOBCARD__EVENT__CALLS__STATUS__COLUMN_ID,
                columnType: "OttopilotEvent",
                driver: OttopilotTriggerDataDriver.staticDefault,
                defaultValue: BobcardCallStatusEnum.SCHEDULED,
            },
            {
                columnId: BOBCARD__EVENT__CALLS__SCHEDULED_BY__COLUMN_ID,
                columnType: "OttopilotEvent",
                driver: OttopilotTriggerDataDriver.workspaceUser,
            },
            {
                columnId: BOBCARD__EVENT__CALLS__SCHEDULED_ON__COLUMN_ID,
                columnType: "OttopilotEvent",
                driver: OttopilotTriggerDataDriver.staticDefault,
                defaultValue: null,
            },
            {
                columnId: BOBCARD__EVENT_CONTAINER__LAST_ACTIVITY__COLUMN_ID,
                columnType: "OttopilotEvent",
                driver: OttopilotTriggerDataDriver.staticDefault,
                defaultValue: BobcardEventTypes.call as Uuid,
            },
            {
                columnId: BOBCARD__EVENT_CONTAINER__LAST_ACTIVITY_ON__COLUMN_ID,
                columnType: "OttopilotEventContainer",
                driver: OttopilotTriggerDataDriver.currentTimestamp,
            },
        ],
        dateTimeColumnId: BOBCARD__EVENT__CALLS__SCHEDULED_ON__COLUMN_ID,
        scheduleFieldLabel: "Schedule call",
        scheduleValueEncoding: OttopilotScheduleValueEncoding.iso8601Instant,
    },
];

export const bobcardDispositionConfig: OttopilotDispositionConfig = {
    emitWhen: OttopilotDispositionEmitWhen.pathMatchesKnownDisposition,
    plugins: [
        {
            kind: OttopilotDispositionPluginKind.dispositionHistory,
            lastN: 20,
        },
        {
            kind: OttopilotDispositionPluginKind.optionRules,
            rules: [
                {
                    id: uniqueUuid`4c97507e-9d6c-40c0-975b-71749a51eb69`,
                    when: {
                        level: 1,
                        selectedPrefix: ["not-connected"],
                    },
                    targetSegment: "not-reachable",
                    countDispositionId:
                        bobcardEventContainerDispositions[BobcardEventContainerDispositionEnum.NOT_CONNECTED_NOT_REACHABLE].id,
                    countMode: OttopilotDispositionOptionRuleCountMode.totalInHistory,
                    action: {
                        kind: OttopilotDispositionOptionRuleActionKind.hideWhenCountGte,
                        max: 6,
                    },
                },
                {
                    id: uniqueUuid`8d8c32ed-260e-4ee9-9b9b-037656a1a984`,
                    when: {
                        level: 1,
                        selectedPrefix: ["not-connected"],
                    },
                    targetSegment: "not-reachable",
                    countDispositionId:
                        bobcardEventContainerDispositions[BobcardEventContainerDispositionEnum.NOT_CONNECTED_NOT_REACHABLE].id,
                    countMode: OttopilotDispositionOptionRuleCountMode.totalInHistory,
                    action: {
                        kind: OttopilotDispositionOptionRuleActionKind.setLabelWhenCountLt,
                        max: 6,
                        labelTemplate: "{segment} ({countNext})",
                    },
                },
                {
                    id: uniqueUuid`000647fc-5ef4-4a01-ba16-bcf93b19f57f`,
                    when: {
                        level: 0,
                        selectedPrefix: [],
                    },
                    targetSegment: "new-lead",
                    countDispositionId: bobcardEventContainerDispositions[BobcardEventContainerDispositionEnum.NEW_LEAD].id,
                    countMode: OttopilotDispositionOptionRuleCountMode.totalInHistory,
                    action: {
                        kind: OttopilotDispositionOptionRuleActionKind.hideWhenHistoryContainsNonAllowedDispositionId,
                        allowedDispositionIds: [bobcardEventContainerDispositions[BobcardEventContainerDispositionEnum.NEW_LEAD].id],
                    },
                },
            ],
        },
        {
            kind: OttopilotDispositionPluginKind.suggestedJourneyStatusRules,
            dispositionStatusColumnId: BOBCARD__EVENT_CONTAINER__STATUS__COLUMN_ID,
            rules: [
                {
                    kind: OttopilotSuggestedJourneyStatusRuleKind.dispositionIdWithConsecutiveHistory,
                    triggerDispositionId:
                        bobcardEventContainerDispositions[BobcardEventContainerDispositionEnum.CONNECTED_CALL_BACK_LATER].id,
                    countDispositionId:
                        bobcardEventContainerDispositions[BobcardEventContainerDispositionEnum.CONNECTED_CALL_BACK_LATER].id,
                    consecutiveMin: 3,
                    suggested: bobcardEventContainerStatuses[BobcardEventContainerStatusEnum.CHURNED].id,
                },
                {
                    kind: OttopilotSuggestedJourneyStatusRuleKind.dispositionIdInSet,
                    dispositionIds: [
                        bobcardEventContainerDispositions[BobcardEventContainerDispositionEnum.NOT_CONNECTED_DEAD_LEAD].id,
                        bobcardEventContainerDispositions[
                            BobcardEventContainerDispositionEnum.CONNECTED_INVALID_DID_NOT_FILL_DEAD_LEAD
                        ].id,
                        bobcardEventContainerDispositions[
                            BobcardEventContainerDispositionEnum.CONNECTED_INVALID_FILLED_BY_MISTAKE_DEAD_LEAD
                        ].id,
                    ],
                    suggested: bobcardEventContainerStatuses[BobcardEventContainerStatusEnum.CHURNED].id,
                },
            ],
        },
    ],
};

/**
 * Leads table view — columns with Table View = TRUE in bobcard_requirement.txt (excludes Fbclid/Gclid).
 * System columns like disposition are appended in the journeys UI.
 */
export const BOBCARD_JOURNEY_TABLE_VISIBLE_COLUMN_IDS: Array<string> = [
    BOBCARD__EVENT_CONTAINER__APPLICATION_ID__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__ALIAS_ID__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__STATUS__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__APPLICATION_STAGE__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__REJECTION_STAGE__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__SELECTED_CARD_VARIANT__COLUMN_ID,
    "updatedAt",
    "createdAt",
    BOBCARD__EVENT_CONTAINER__INTERESTED_CARD_VARIANT__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__UTM_PLATFORM__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__UTM_SOURCE__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__UTM_MEDIUM__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__UTM_CAMPAIGN__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__UTM_CONTENT__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__UTM_TERM__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__CUSTOMER_NAME__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__FIRST_NAME__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__LAST_NAME__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__DATE_OF_BIRTH__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__CONTACT_NUMBER__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__EMPLOYMENT_STATUS__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__NET_MONTHLY_INCOME_NET_ANNUAL__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__CURRENT_PINCODE__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__GENDER__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__MARITAL_STATUS__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__EMAIL_ADDRESS__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__PAN_NUMBER__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__COMPANY_NAME__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__COMPANY_ADDRESS__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__PERMANENT_ADDRESS__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__CURRENT_ADDRESS__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__PAN_VALIDATION__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__CREDIT_HISTORY__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__CREDIT_SCORE__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__AADHAR_NUMBER__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__AADHAR_VERIFICATION__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__NETWORK_SELECTED__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__E_CONSENT__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__V_KYC_SUCCESSFUL__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__UPI_LINKAGE__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__REMARKS_RECENT__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__LEAD_COUNT__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__LAST_ACTIVITY__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__LAST_ACTIVITY_ON__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__LEAD_OWNER__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__ENQUIRY_COUNT__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__CALLS_COUNT__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__ASSIGNED_ON__COLUMN_ID,
    "updatedBy",
    BOBCARD__EVENT_CONTAINER__REFERRER__COLUMN_ID,
    "disposition",
];

export const BOBCARD_JOURNEY_INITIAL_FILTER_COLUMN_ID = BOBCARD__EVENT_CONTAINER__CUSTOMER_NAME__COLUMN_ID;

/** Enquiries list table — Table View = TRUE per requirement (first/last come from journey). */
export const BOBCARD_ENQUIRY_EVENT_TABLE_VISIBLE_COLUMN_IDS: Array<string> = [
    BOBCARD__EVENT__ENQUIRY__CUSTOMER_NAME__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__FIRST_NAME__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__LAST_NAME__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__APPLICATION_STAGE__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__REJECTION_STAGE__COLUMN_ID,
    BOBCARD__EVENT__ENQUIRY__CONTACT_NUMBER__COLUMN_ID,
    BOBCARD__EVENT__ENQUIRY__DIGITAL_LEAD_STATUS__COLUMN_ID,
    BOBCARD__EVENT__ENQUIRY__UTM_PLATFORM__COLUMN_ID,
    BOBCARD__EVENT__ENQUIRY__UTM_SOURCE__COLUMN_ID,
    BOBCARD__EVENT__ENQUIRY__UTM_MEDIUM__COLUMN_ID,
    BOBCARD__EVENT__ENQUIRY__UTM_CAMPAIGN__COLUMN_ID,
    BOBCARD__EVENT__ENQUIRY__UTM_TERM__COLUMN_ID,
    BOBCARD__EVENT__ENQUIRY__UTM_CONTENT__COLUMN_ID,
    BOBCARD__EVENT__ENQUIRY__REFERRER__COLUMN_ID,
    "disposition",
    "status",
    "createdAt",
    "createdBy",
    "updatedAt",
];

/** Calls list table — Table View = TRUE per requirement (logged remarks excluded from table). */
export const BOBCARD_CALL_EVENT_TABLE_VISIBLE_COLUMN_IDS: Array<string> = [
    BOBCARD__EVENT_CONTAINER__CUSTOMER_NAME__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__CONTACT_NUMBER__COLUMN_ID,
    BOBCARD__EVENT__CALLS__CALL_TYPE__COLUMN_ID,
    BOBCARD__EVENT__CALLS__STATUS__COLUMN_ID,
    BOBCARD__EVENT_CONTAINER__LEAD_OWNER__COLUMN_ID,
    BOBCARD__EVENT__CALLS__CALL_DISPOSITION__COLUMN_ID,
    BOBCARD__EVENT__CALLS__SCHEDULED_BY__COLUMN_ID,
    BOBCARD__EVENT__CALLS__SCHEDULED_ON__COLUMN_ID,
    BOBCARD__EVENT__CALLS__LOGGED_BY__COLUMN_ID,
    BOBCARD__EVENT__CALLS__LOGGED_ON__COLUMN_ID,
    BOBCARD__EVENT__CALLS__CANCELLED_BY__COLUMN_ID,
    BOBCARD__EVENT__CALLS__CANCELLED_ON__COLUMN_ID,
    BOBCARD__EVENT__CALLS__CANCELLATION_REMARKS__COLUMN_ID,
    BOBCARD__EVENT__CALLS__UTM_PLATFORM__COLUMN_ID,
    "disposition",
    "createdAt",
    "createdBy",
    "updatedAt",
];
